<template>
  <b-container fluid>
    <TopBar id="top-bar"></TopBar>
    <div class="row step block_import">
      <b-col>
        <h2 class="step_title">{{ step_infos[current_step].title }}</h2>
        <p class="step_instruction">{{ step_infos[current_step].desc }}</p>
        <AssociationModule v-show="current_step == 0" :list_modules="lists.modules" @changeSelectedModule="changeSelectedModule"></AssociationModule>
        <ImportGMCAP v-show="current_step == 1" :list_exports="lists.exports" @changeSelectedExport="setExportFromServer" @uploadExport="setExportFromDesktop"></ImportGMCAP>
        <InformationsSupplementaires v-show="current_step == 2" :module_infos="module.informations" :list_diplomes="lists.diplomes" @changeSelectedDiplome="setDiplome" @uploadFlyer="setFlyer"></InformationsSupplementaires>
        <AdditionnalLinks v-show="current_step == 3" :additionnal_links="module.informations.additionnal_links"></AdditionnalLinks>
        <AdditionnalFiles v-show="current_step == 3" :additionnal_files="module.informations.additionnal_files" @uploadAdditionnalFiles="setAdditionnalFiles"></AdditionnalFiles>

        <ChallengeCourse v-show="current_step == 4" v-if="raw_resultats.length > 0" :raw_challenges="module.informations.challenges" :raw_resultats="raw_resultats" class="block_import" @updateChallenges="setChallenges"></ChallengeCourse>
        <ChallengeCourseEquipe
          v-show="current_step == 4"
          v-if="raw_resultats.length > 0"
          :raw_challenges_equipe="module.informations.challenges_equipe"
          :raw_resultats="raw_resultats"
          class="block_import"
          @updateChallengesEquipes="setChallengesEquipes"
        ></ChallengeCourseEquipe>
        <RassemblementCourse
          v-show="current_step == 4"
          v-if="raw_resultats.length > 0"
          :raw_rassemblement="module.informations.rassemblements_course"
          :raw_resultats="raw_resultats"
          class="block_import"
          @updateRassemblement="setRassemblementCourse"
        ></RassemblementCourse>
        <CourseCumulInter v-show="current_step == 4" v-if="raw_resultats.length > 0" :raw_course_cumul="module.informations.courses_cumul" :raw_resultats="raw_resultats" class="block_import" @updateCoursesCumul="setCoursesCumul"></CourseCumulInter>
        <CourseCumulInterEquipe
          v-show="current_step == 4"
          v-if="raw_resultats.length > 0"
          :raw_course_cumul_equipe="module.informations.courses_cumul_equipe"
          :raw_resultats="raw_resultats"
          class="block_import"
          @updateCoursesCumulEquipe="setCoursesCumulEquipe"
        ></CourseCumulInterEquipe>

        <Formater v-show="current_step == 5" v-if="raw_resultats.length > 0" :raw_resultats="raw_resultats" @launchUpload="launchUpload"></Formater>
        <div class="btn_navigation">
          <b-button size="sm" v-if="current_step > 0" @click="current_step--"><v-icon name="caret-left" /> Précedent</b-button>
          <b-button size="sm" v-if="current_step < 5" @click="current_step++">Suivant <v-icon name="caret-right" /></b-button>
        </div>
        <b-progress :value="current_step + 1" :max="6" class="mb-3"></b-progress>
      </b-col>
    </div>

    <FullScreenLoading v-if="loading" action="Envoi des résultats en cours"></FullScreenLoading>
    <FullScreenConfirmation v-if="confirmation.status" :id="confirmation.id"></FullScreenConfirmation>
  </b-container>
</template>

<script>
import AssociationModule from "@/component/Import/AssociationModule.vue";
import ImportGMCAP from "@/component/Import/ImportGMCAP.vue";
import InformationsSupplementaires from "@/component/Import/InformationsSupplementaires.vue";
import Formater from "@/component/Import/Formater.vue";
import ChallengeCourse from "@/component/Import/ChallengeCourse.vue";
import RassemblementCourse from "@/component/Import/RassemblementCourse.vue";
import ChallengeCourseEquipe from "@/component/Import/ChallengeCourseEquipe.vue";
import CourseCumulInter from "@/component/Import/CourseCumulInter.vue";
import CourseCumulInterEquipe from "@/component/Import/CourseCumulInterEquipe.vue";
import AdditionnalFiles from "@/component/Import/AdditionnalFiles.vue";
import AdditionnalLinks from "@/component/Import/AdditionnalLinks.vue";
import FullScreenLoading from "@/component/FullScreenLoading";
import FullScreenConfirmation from "@/component/Import/FullScreenConfirmation";
import TopBar from "@/component/Import/TopBar";
import Axios from "axios";
export default {
  components: {
    AssociationModule,
    ImportGMCAP,
    InformationsSupplementaires,
    AdditionnalFiles,
    AdditionnalLinks,
    ChallengeCourse,
    Formater,
    FullScreenLoading,
    FullScreenConfirmation,
    ChallengeCourseEquipe,
    CourseCumulInter,
    CourseCumulInterEquipe,
    RassemblementCourse,
    TopBar,
  },

  data() {
    return {
      module: {
        id: 0,
        informations: {
          nom: "",
          date_epreuve: "",
          ville_competition: "",
          code_ville_competition: "",
          type_competition: "",
          annee_epreuve: "",
          url_flyer: "",
          diplome: null,
          additionnal_links: [{ title: "", url: "" }],
          additionnal_files: [{ title: "", url: "" }],
          challenges: [],
          challenges_equipe: [],
          rassemblements_course: [],
          courses_cumul: [],
          courses_cumul_equipe: [],
        },
        url_export: "",
        source_export: "",
      },
      lists: {
        modules: [],
        exports: [],
      },
      raw_resultats: [],
      current_step: 0,
      step_infos: [
        { title: "Etape 1 - Associer à un module", desc: "Selectionner le module auquel sont associés les résultats à importer. S'il n'y a pas de module, veuillez laisser ce champs vide." },
        { title: "Etape 2 - Source des résultats", desc: "Pour une mise à jour automatique des résultats, vous pouvez sélectionner l'export GMCAP depuis le serveur." },
        { title: "Etape 3 - Information sur la compétition", desc: "Ces informations sont pré-remplies par le module ainsi que le GMCAP sélectionnés lors des étapes précedentes" },
        { title: "Etape 4 - Liens supplémentaires à intégrer aux résultats (Optionnel)", desc: "Vous pouvez ajouter des liens supplémentaires à associer aux résultats. Par exemple le lien vers la galerie photo." },
        {
          title: "Etape 5 - Challenge multi course et cumul d'intermédiaires (Optionnel)",
          desc: "S'il existe un challenge multi course ou une course en cumul d'intermédiaires sur cet évenement, vous pouvez le paramétrer ici. Sinon passez à l'étape suivante",
        },
        { title: "Etape 6 - Configuration des résultats", desc: "Pour chaque course, vous pouvez définir le type de course, ainsi que le type de champs à afficher dans le tableau de résultat." },
      ],
      loading: false,
      confirmation: { status: false, id: 0 },
    };
  },
  methods: {
    pausecomp(millis) {
      var date = new Date();
      var curDate = null;
      do {
        curDate = new Date();
      } while (curDate - date < millis);
    },
    launchUpload(c) {
      var _this = this;
      this.loading = true;
      this.module.courses = c;
      var data = {
        action: "insertDesktopResults",
        module: this.module,
      };
      if (this.module.source_export === "desktop") {
        data.raw_resultats = this.raw_resultats;
      }
      Axios.post(this.$store.getters.base_url + "/import/results/post.php", data).then(function (response) {
        console.log(response.data);
        _this.pausecomp(1000);
        _this.loading = false;
        if (parseInt(response.data) > 0) {
          _this.confirmation.status = true;
          _this.confirmation.id = parseInt(response.data);
        }
      });
    },
    /* Au changement d'association de module */
    changeSelectedModule(e) {
      this.module.id = e;
      this.setUrlFlyer();
    },

    setUrlFlyer() {
      for (var i = 0; i < this.lists.modules.length; i++) {
        if (this.module.id === this.lists.modules[i].value) {
          var base = this.lists.modules[i].text.split(" | ")[0];
          this.module.informations.url_flyer = "https://sportips.fr/" + base + "/img/flyer.jpg";
        }
      }
    },

    /* Si l'export est selectionné depuis ceux disponible sur le server */
    setExportFromServer(e) {
      this.module.url_export = "https://sportips.fr/live/export_live/Export_GMCAP/" + e;
      this.module.source_export = "server";
      var _this = this;

      var data = new FormData();
      data.append("url", this.module.url_export);
      Axios.post(this.$store.getters.base_url + "/import/export/get.php", data).then(function (response) {
        _this.raw_resultats = response.data;
        console.log(_this.raw_resultats);
      });
    },

    /* Si l'export est chargé depuis le PC */
    setExportFromDesktop(e) {
      this.module.url_export = "https://sportips.fr/plateformeResultats/gmcap/" + e.filename;
      this.raw_resultats = e.content.data;
      this.module.source_export = "desktop";
    },
    /* Si un diplome est selectionné */
    setDiplome(e) {
      this.module.informations.diplome = e;
    },
    /* Si un flyer est uploadé */
    setFlyer(e) {
      this.module.informations.url_flyer = e;
    },

    /* Si un fichier supplémentaire est uploadé */
    setAdditionnalFiles(e) {
      this.module.informations.additionnal_files[e.index].url = e.url;
    },

    setChallenges(e) {
      this.module.informations.challenges = e;
    },
    setChallengesEquipes(e) {
      this.module.informations.challenges_equipe = e;
    },
    setCoursesCumul(e) {
      this.module.informations.courses_cumul = e;
    },
    setCoursesCumulEquipe(e) {
      this.module.informations.courses_cumul_equipe = e;
    },

    setRassemblementCourse(e) {
      this.module.informations.rassemblements_course = e;
    },
    /* Récupère la liste des modules et exports récents pour remplir les selects */
    fetchLists() {
      var _this = this;
      Axios.get(this.$store.getters.base_url + "/import/modules/get.php?action=select").then(function (response) {
        _this.lists.modules = response.data;
        _this.lists.modules.unshift({ text: "Aucun module associé", value: null });
      });
      Axios.get(this.$store.getters.base_url + "/import/exports/get.php").then(function (response) {
        _this.lists.exports = response.data;
      });
      Axios.get(this.$store.getters.base_url + "/import/diplomes/get.php?action=select").then(function (response) {
        _this.lists.diplomes = response.data;
      });
    },
  },
  watch: {
    raw_resultats() {
      for (var i = 0; i < this.raw_resultats.length; i++) {
        if (this.raw_resultats[i]["Competition"] != "") {
          var first_row = this.raw_resultats[i];
          this.module.informations.nom = first_row["Competition"];
          this.module.informations.date_epreuve = first_row["Date Compet."];
          this.module.informations.ville_competition = first_row["Ville Compet."];
          this.module.informations.code_ville_competition = first_row["Code Ville Compet."];
          this.module.informations.type_competition = first_row["Type Compet."];
          this.module.informations.annee_epreuve = first_row["Date Compet."].slice(-4);
          return;
        }
      }
    },
  },
  created() {
    this.fetchLists();
  },
};
</script>

<style>
.block_import {
  font-size: 13px;
  background-color: #e2e2e2;
  border: 1px solid #999;
  border-radius: 3px;
  margin: 15px 5px;
  padding-top: 15px;
}
.block_import .col,
.block_import p {
  text-align: left;
}
.block_import p {
  margin-bottom: 0;
  line-height: 38px;
}

.block_import legend {
  font-weight: bold;
}
.step {
}
.step_title {
  text-decoration: underline;
  font-weight: bold;
}
.btn_navigation {
  margin-top: 40px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 5px;
}
.progress-bar {
  background-color: #f29200 !important;
}
</style>



// WEBPACK FOOTER //
// src/view/ImportSimplify.vue